import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

export interface Notification {
  title: string;
  date: Date;
  status: string;
}

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.css']
})
export class NotificationListComponent  implements OnInit {
  displayedColumns: string[] = ['title', 'date', 'status'];
  dataSource = new MatTableDataSource<Notification>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngOnInit() {
    // Mock data - Replace with API call
    const mockData: Notification[] = [
      { title: 'New Message', date: new Date(), status: 'Unread' },
      { title: 'System Update', date: new Date(), status: 'Read' },
      { title: 'Reminder', date: new Date(), status: 'Unread' },
      // Add more data
    ];
    this.dataSource.data = mockData;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
   filterByStatus(status: any) {
    this.dataSource.filterPredicate = (data, filter) =>
      !filter || data.status.toLowerCase() === filter;
    this.dataSource.filter = status.toLowerCase();
  }

  

}